import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TutorService {

  public msgError: any = ""

  constructor(private _httpClient: HttpClient,) { }

  tutorGetMemberSituation (doc): Observable<any> {
    this.msgError = ''

    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/tutorGetMemberSituation';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const body: any = {'doc': doc}
    console.log("doc: " + JSON.stringify(body))

    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError((error) => {
          // console.log(JSON.stringify(error))
          return throwError(error);
        })
      )
  }


}
